export const FooterLink2 = [
  {
    title: "Free Resources",
    links: [
      { title: "Blog", link: "/blogs" },
      { title: "Free Newsletter", link: "/newsletter" },
    ],
  },
];
